import Header from "../header"
import "./index.css"
import TaskBar from "../taskbar";
import CopyRight from "../copyright";

const CountrieFrance = () => {

    return (
        <>
        <Header />
        <div className="container-head">
          <h1>Why Choose France as Your Study Destination?</h1>  
          <p>France boasts a globally renowned education system, a vibrant and diverse culture, and a captivating environment for students from around the world.  </p>
        <p>Key Advantages:  </p>
        <ul>
            <li> Globally Recognized Universities: Institutions like Sorbonne University, HEC Paris, and École Polytechnique offer outstanding programs.   </li>
           <li>Affordable Tuition Fees: Public universities offer world-class education at highly competitive costs.  </li>
           <li>Wide Range of Programs: Business, engineering, arts, fashion, technology, and more.</li>
           <li>Cultural Diversity: A rich multicultural environment welcoming students from around the globe. </li>
           <li>Post-Study Work Opportunities: Generous work visa options for international graduates.  </li>
           <li>Gateway to Europe: Strategic location offering travel and business opportunities across the EU.  </li>
        </ul>

        <hr />
        <table>
            <caption>Quick Facts About Studying in France </caption>
            <thead>
                <tr>
                    <th>Category</th>
                    <th>Details</th>
                </tr>
            </thead>
                <tr>
                    <td>Official Language</td>
                    <td>French (many programs available in English)  </td>
                </tr>
                <tr>
                    <td>Currency </td>
                    <td>Euro (€) </td>
                </tr>
                <tr>
                    <td>Major Intakes</td>
                    <td>September & January  </td>
                </tr>
                <tr>
                    <td>Top Universities </td>
                    <td>Sorbonne University, Université PSL, HEC Paris, INSEAD, École Polytechnique</td>
                </tr>
                <tr>
                    <td>International Students </td>
                    <td>400,000+ </td>
                </tr>
                <tr>
                    <td>Average Tuition Fees  </td>
                    <td>€2,500–€20,000 per year </td>
                </tr>
                <tr>
                    <td>Popular Cities </td>
                    <td>Paris, Lyon, Toulouse, Bordeaux, Lille </td>
                </tr>
        </table>
        

        <hr />

        <h2>Popular Courses in France </h2>

        <ul>
            <li>Business Administration (MBA) </li>
            <li>Aviation and Aerospace Engineering </li>
            <li>Luxury Brand Management </li>
            <li>Fashion Design and Arts </li>
            <li>Biotechnology and Biomedical Sciences </li>
            <li>Data Science, Analytics, and Cloud Computing </li>
            <li>Computer Science and Cybersecurity </li>
            <li>Culinary Arts and Hospitality Management </li>
            <li>Marketing, Branding, and Digital Communication </li>
        </ul>
        <hr />
        <h2>Cost of Studying in France </h2>
        <table>
            <thead>
                <tr>
                    <th>Institution Type </th>
                    <th>Tuition Fees (per year)  </th>
                </tr>
            </thead>
                <tr>
                    <td>Public Universities </td>
                    <td>€2,000–€5,000</td>
                </tr>
                <tr>
                    <td>Grandes Écoles / Business Schools</td>
                    <td>€8,000–€20,000 </td>
                </tr>
                <tr>
                    <td>Private Institutions</td>
                    <td>€10,000–€20,000 </td>
                </tr>
                </table>
                <p>Additional Academic Costs: €200–€500/year for books, materials, and lab fees. </p>
                <hr/>
                <h2>Cost of Living in France </h2>
            <table>
            <thead>
                <tr>
                    <th>Expense </th>
                    <th>Estimated Cost (Monthly) </th>
                </tr>
            </thead>
                <tr>
                    <td>Accommodation (Paris) </td>
                    <td>€1,200–€2,500  </td>
                </tr>
                <tr>
                    <td>Accommodation (Other Cities)</td>
                    <td>€600–€1,200  </td>
                </tr>
                <tr>
                    <td>Groceries</td>
                    <td>€150–€250  </td>
                </tr>
                <tr>
                    <td>Public Transport Pass</td>
                    <td>€600–€1,200  </td>
                </tr>
                <tr>
                    <td>Dining Out (Meal) </td>
                    <td>€10–€30 </td>
                </tr>
                <tr>
                    <td>Entertainment </td>
                    <td>€100–€200  </td>
                </tr>
                </table>
                <p>Tip: Living outside Paris can significantly reduce your living expenses. </p>
            <hr />
            <h2>Scholarships to Study in France  </h2>
            <table>
            <thead>
                <tr>
                    <th>Scholarship </th>
                    <th>Provider </th>
                    <th>Coverage </th>
                </tr>
            </thead>
                <tr>
                    <td>Eiffel Excellence Scholarship</td>
                    <td>French Government </td>
                    <td>Tuition, travel, living expenses</td>
                </tr>
                <tr>
                    <td>Legrand Empowering Scholarship </td>
                    <td>Legrand Group </td>
                    <td>Master's program support for Indian students </td>
                </tr>
                <tr>
                    <td>Campus France Scholarships  </td>
                    <td>Various  </td>
                    <td>Merit- and need-based funding </td>
                </tr>
                <tr>
                    <td>Erasmus+ Program </td>
                    <td>EU Initiative </td>
                    <td>Mobility and exchange support </td>
                </tr>
                <tr>
                    <td>Charpak Scholarship </td>
                    <td>French Embassy in India </td>
                    <td>Tuition fee aid for master's programs </td>
                </tr>
                <tr>
                    <td>Regional Scholarships </td>
                    <td>Local French Regions  </td>
                    <td>Tuition and living assistance </td>
                </tr>
                </table>
            <hr />
            <h2>Documents Required for Admission and Visa  </h2>
               <ul>
                  <li>Valid Passport </li>
                  <li>Completed Visa Application Form </li>
                  <li>Admission Offer Letter </li>
                  <li>Academic Transcripts and Certificates </li>
                  <li>Proof of Language Proficiency (IELTS/French) </li>
                  <li>Statement of Purpose (SOP)</li>
                  <li>Updated Curriculum Vitae (CV) </li>
                  <li>Letters of Recommendation (LORs)</li>
                  <li>Proof of Funds (Bank Statements) </li>
                  <li>Health Insurance </li>
                  <li>Proof of Accommodation </li>
                  <li>Passport-Size Photographs </li>
                  <li>Visa Fee Payment Receipt </li>
                  <li>Medium of Instruction Certificate (if applicable) </li>
               </ul>

           <hr />

           <h2>France Student Visa Process: Step-by-Step</h2>
           <ul>
            <li>Choose Your Program: Get accepted into a recognized institution.  </li>
            <li>Prepare Documentation: Admission letter, proof of funds, accommodation, insurance, etc.  </li>
            <li>Apply Online: Submit your visa application via the Campus France portal.  </li>
            <li>Visa Interview: Attend an interview if required by your consulate.  </li>
            <li>Visa Fee Payment: Pay the visa application fees.  </li>
            <li>Await Approval: Processing usually takes 2–4 weeks. </li>
            <li>Arrive and Register: Validate your visa upon arrival in France.  </li>
           </ul>
            <hr/>
            <h2>Post-Study Work Opportunities in France  </h2>
            <ul>
                <li>International graduates can apply for a Temporary Resident Permit (APS) valid for up to 12 months to seek employment.  </li>
                <li>STEM graduates may extend the APS up to 24 months.  </li>
                <li>Work experience gained during this period can enhance PR application prospects.</li>
            </ul>
            <hr/>
            <h2>FAQs About Studying in France </h2>
            <table>
                <thead>
                    <tr>
                        <th>Question </th>
                        <th>Answer</th>
                    </tr>
                </thead>
                <tr>
                    <td>How much does it cost to study? </td>
                    <td>€2,000–€20,000/year, depending on program and institution.</td>
                </tr>
                <tr>
                    <td>Can I work while studying? </td>
                    <td>Yes, up to 964 hours/year (20 hours/week)</td>
                </tr>
                <tr>
                    <td>Are courses available in English? </td>
                    <td>Yes, many top programs are fully in English. </td>
                </tr>
                <tr>
                    <td>Are scholarships available? </td>
                    <td>Yes, through Campus France, Eiffel Scholarship, universities, and regional grants.</td>
                </tr>
                <tr>
                    <td>What is the post-study work option? </td>
                    <td>Apply for a Temporary Resident Permit (APS) after graduation for job search or entrepreneurship. </td>
                </tr>
            </table>
       
        </div>
        <TaskBar />
        <CopyRight />
        </>
    )

}

export default CountrieFrance